import { css } from '@emotion/core';

export const mobile = '640px';

export const basicTable = css`
  width: 100%;
  border-collapse: collapse;
`;

export const orderFilters = css`
  & input,
  & select,
  & .DayPickerInput {
    display: block;
    box-sizing: border-box;
    width: 100%;
  }
`;

export const orderTable = css`
  ${basicTable}
  text-align: left;
  font-feature-settings: 'tnum';

  .number {
    text-align: right;
  }
`;

export const orderDetails = css`
  h2 {
    margin-top: 0;
  }
`;

export const headerTable = css`
  text-align: left;

  th {
    padding-right: 12px;
  }
`;

export const detailsWrapper = css`
  overflow: auto;
`;

export const detailsTable = css`
  text-align: left;
  width: 100%;

  th,
  td {
    padding: 5px;
  }
  
  .number {
    text-align: right;
  }

  @media screen and (max-width: ${mobile}) {
    
    thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }
    
    tr {
      border: 1px solid #ddd;
      display: block;
      margin-bottom: 1em;
    }
    
    td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: .8em;
      text-align: right;
    }
    
    td::before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
    }
    
     td:last-child {
      border-bottom: 0;
    }
`;

export const footerTable = css`
  text-align: left;
  width: 100%;
  th {
    padding-right: 12px;
  }
  td {
    text-align: right;
  }
`;
